import { Theme } from '@emotion/react';
import { SxProps, TableCell, Tooltip } from '@mui/material';
import React from 'react';
import { TEMPLE } from '../common/templeStyles';

interface CommonTableCellProps {
  value: React.ReactNode | string | number;
  formatDate?: boolean;
  textOverflow?: boolean;
  dateFormat?: string;
  style?: SxProps<Theme>;
  title?: string;
  [key: string]: any;
}

const CommonTableCell = ({ value, formatDate = false, textOverflow = true, dateFormat = 'short', style, title, ...props }: CommonTableCellProps) => {
  const formatDateValue = (date: Date | string | number) => {
    const parsedDate = date instanceof Date ? date : new Date(date);

    if (isNaN(parsedDate.getTime())) return 'Invalid Date';

    return new Intl.DateTimeFormat('en-GB', {
      day: '2-digit',
      month: 'short',
      year: 'numeric',
    }).format(parsedDate);
  };

  const formattedValue =
    formatDate &&
    (typeof value === 'string' ||
      typeof value === 'number' ||
      value instanceof Date)
      ? formatDateValue(value)
      : value;

  const cell = (
    <TableCell
      className="tcell"
      sx={{
        overflow: textOverflow ? 'hidden' : 'visible',
        textOverflow: textOverflow ? 'ellipsis' : 'clip',
        whiteSpace: 'nowrap',
        borderBottom: `1px solid ${TEMPLE.line}`,
        color: TEMPLE.inkM,
        padding: 1,
        ...style,
      }}
      {...props}
    >
      {formattedValue}
    </TableCell>
  );

  return title?.length ? (
    <Tooltip title={title} arrow>
      {cell}
    </Tooltip>
  ) : (
    cell
  );
};

export default CommonTableCell;
